import { useEffect } from "react"
import { useAppSelector } from "@/store"
import { DevToolsSelectors, ITgInsets } from "@/store/slices/devTools"

export const useTgInsetsEmulation = () => {
  const insets = useAppSelector(DevToolsSelectors.selectTgInsets())

  useEffect(() => {
    if (!import.meta.env.DEV) return
    const root = document.documentElement
    const keys = Object.keys(insets) as (keyof ITgInsets)[]
    keys.forEach((key) => {
      root.style.setProperty(`--tg-${key}`, `${insets[key]}px`, "important")
    })
  }, [insets])
}
